module.exports = __webpack_public_path__ + "img/info_20.23b4fc4b.svg";